import { Box } from "@mui/material";
import PropTypes from "prop-types";
import React, { memo } from "react";

function IconBase({ src = "", width = 20, height = 20 }) {
  return (
    <Box
      sx={{
        backgroundImage: `url(${src})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100%",
        width: `${width}px`,
        height: `${height}px`,
      }}
    />
  );
}

IconBase.propTypes = {
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default memo(IconBase);
